import { __rest } from 'tslib';
import React from 'react';
import { extractMarginProps, extractDimensionProps } from '@10d/tend-ui-styling';
import { useColor } from '@10d/tend-ui-theme';
import { Root } from './styled.js';

const BaseText = (_a, ref) => {
    var { size = 'medium', uppercase, color, textAlign, fontWeight = 400, className, wordBreak, whiteSpace } = _a, props = __rest(_a, ["size", "uppercase", "color", "textAlign", "fontWeight", "className", "wordBreak", "whiteSpace"]);
    const _color = useColor(color);
    const _b = extractMarginProps(props), { rest: withoutMargins } = _b, margins = __rest(_b, ["rest"]);
    const _c = extractDimensionProps(withoutMargins), { rest } = _c, dimensions = __rest(_c, ["rest"]);
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-text' }, rest, margins, dimensions, { ref: ref, "$uppercase": uppercase, "$size": size, "$color": _color, "$textAlign": textAlign, "$fontWeight": fontWeight, "$wordBreak": wordBreak, "$whiteSpace": whiteSpace, className: ['tend-ui-typography-text', className].filter(Boolean).join(' ') })));
};
const Text = React.forwardRef(BaseText);
Text.displayName = 'Text';

export { Text };
//# sourceMappingURL=Text.js.map
